import VaultedCardsButton from "../components/VaultedCardsButton";
import CartSummaryButton from "../components/CartSummaryButton";
import ContentSection from "../components/ContentSection";
import VaultedCardList from "../components/VaultedCardList";
import Footer from "../components/Footer";
import HomeButton from "../components/HomeButton";
import NavBar from '../components/NavBar';
import TitleSection from "../components/TitleSection";
import UserCard from "../components/UserCard";
import AddNewCardModalButton from "../components/AddNewCardModalButton";
import { DropdownMenu } from "../components/DropdownMenu";
import LandingButton from "../components/LandingButton";

function CardsPage() {
    return (
        <div className='body'>
            <NavBar
                left={
                    <>
                      <HomeButton />
                      <DropdownMenu>
                        <LandingButton/>
                        <VaultedCardsButton/>
                      </DropdownMenu>
                    </>
                }
                right={<><CartSummaryButton /><UserCard /></>}
            />
            <TitleSection text='Cards'/>
            <ContentSection>
                <VaultedCardList />
                <AddNewCardModalButton />
            </ContentSection>
            <Footer />
        </div>
    )
}

export default CardsPage